import { render, staticRenderFns } from "./createTollFree.vue?vue&type=template&id=6282dda9&"
import script from "./createTollFree.vue?vue&type=script&lang=js&"
export * from "./createTollFree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports